import Api from 'src/api/Base'

class GetAvailablePreviewSspsas extends Api {
  requestUrl = `/api/Psa/available/preview`
}

export default GetAvailablePreviewSspsas
